module.exports = __webpack_public_path__ + "img/plus.b45dfb7b.svg";